export default __webpack_public_path__ + "static/media/IndaraPLC.919b2715.png";